/**
 * Utility functions for custom fields caching
 */

/**
 * Generate a cache key for custom fields based on container path
 */
export function getCustomFieldsCacheKey(spaceName?: string, folderPath?: string[], listName?: string): string {
    return `${spaceName || ''}:${folderPath?.[0] || ''}:${listName || ''}`;
}

